<template>
  <div class="member-list">
    <div class="container">  
      <h1 class="headline"><img :src="beltsPath + belt.icon" v-if="belt !== null"></h1>
      <p v-if="members != null" class="light">{{members.length}} {{$t('message.membersFound')}}</p>
      <div class="loading" v-if="members.length === 0"></div>      
      
      <!--div class="list-search-outer">
        <input class="list-search" type="text" v-model="searchString" :placeholder="$t('message.search')"></input>
        <div v-if="members != null" class="list-search-subline" >
          {{searchResults.length}} found <span @click="goNextFoundInList">+</span><span @click="goNextFoundInList">-</span>
        </div>
      </div-->
      
      <div class="list-outer" v-if="members.length > 0">         
      
        <div class="list-item" v-for="item in members" :key="item.map" :id="'member' + item.map" @click="goMember(item)" :class="{highlight: (item.firstname + ' ' + item.lastname).toUpperCase().includes(searchString.toUpperCase()) && searchString.length > 3}">  
          <div class="list-item-image"><img :src="item.memberImage" @error="onImageError"/></div>
          <div class="list-item-caption">
            <div class="list-item-title">{{item.firstname}} {{item.lastname}}</div>
            <div class="list-item-subtitle">MAP {{item.map}}</div>
          </div>
          <div class="list-item-additionals">
            <div class="list-item-additional hide-mobile"><img :src="logoPath + item.dojo_id + '.jpg'" @error="onLogoImageError"/></div>            
            <div class="list-item-additional"><img class="list-flag" :src="flagsPath + item.country_image"/></div>       
          </div>         
        </div> 
       
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  name: 'membersWithCountry',
  data () {
    return {
      country: null,
      beltId: 0,
      belt: null,
      searchString: '',
      searchResults: [],
      searchResultIndex: 0,
      paginationIndex: 1
    }
  },
  methods: {
    getMembers: function () {
      this.$store.dispatch('members/getBeltMembers', this.beltId)
    },
    getBelts: function () {
      this.$store.dispatch('members/getBelts').then(() => {
        this.belt = this.getBelt(this.beltId)
        console.log('belts received')
        // console.log(this.getBelt(this.belt))
        console.log(_.find(this.belts, (o) => o.id === this.beltId))
        this.getMembers()
      })
    },
    goMember: function (item) {
      var breadcrumb = {
        name: item.firstname + ' ' + item.lastname,
        route: '/member/' + item.map
      }
      this.$store.commit('ADD_BREADCRUMB', breadcrumb)
      this.$router.push(breadcrumb.route)
    },
    goFoundInList: function () {
      var el = document.getElementById('member' + this.searchResults[this.searchResultIndex].map)
      el.scrollIntoView({behavior: 'smooth', block: 'center'})
      // console.log(document.getElementsByClassName('content')[0]) // .scrollTop -= 80
    },
    goNextFoundInList: function () {
      if (this.searchResultIndex < this.searchResults.length - 1) {
        this.searchResultIndex++
      } else {
        this.searchResultIndex = 0
      }
      this.goFoundInList()
    },
    goPrevFoundInList: function () {
      if (this.searchResultIndex > 0) {
        this.searchResultIndex--
      } else {
        this.searchResultIndex = this.searchResults.length - 1
      }
      this.goFoundInList()
    },
    onLogoImageError: function (event) {
      event.target.src = './dojo-dummy.png'
    },
    onImageError: function (event) {
      event.target.src = './person-dummy.png'
    }
  },
  watch: {
    searchString: function () {
      var searchString = this.searchString
      if (this.members !== null && searchString.length > 3) {
        this.searchResults = _.filter(this.members, function (o) { return (o.firstname + ' ' + o.lastname).toUpperCase().includes(searchString.toUpperCase()) })
        this.goFoundInList()
      } else {
        this.searchResults = []
      }
    }
  },
  computed: {
    ...mapGetters({
      belts: 'members/belts',
      getBelt: 'members/getBelt',
      members: 'members/beltMembers',
      flagsPath: 'countries/flagsPath',
      beltsPath: 'members/beltsPath',
      logoPath: 'dojos/logoPath'
    })
  },
  activated: function () {
    this.beltId = this.$route.params.id
    this.getBelts()
    console.log('members: ')
    console.log(this.members)
  }
}
</script>
